import { ApolloCache } from 'apollo-cache';
import { onError } from 'apollo-link-error';
import { postErrorAlert } from '../clientState/alerts/services';
import getClientEnvironment from '../getClientEnvironment';

const config = getClientEnvironment();

export default (cache: ApolloCache<any>) =>
    onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) => {
                // Post an error to notify the user
                postErrorAlert(message, cache);
            });
        }
        if (networkError) {
            // Post an error to notify the user
            postErrorAlert(
                `Network error when connecting to the ${config.TITLE} server`,
                cache
            );
        }
    });



// WEBPACK FOOTER //
// ./src/client/apollo/configureErrorLink.tsx